export default __webpack_public_path__ + "static/images/byp-header.73d2e5f6f59b4937a08eac6810a2e98e.png";